import { parseTopic } from './parseTopic';
import { parseNewTourn } from './parseNewTourn';
import { parseNewMatch } from './parseNewMatch';
import { parseNewMatchPool } from './parseNewMatchPool';
import { parseNewTournPool } from './parseNewTournPool';
import { parseUpdTourn } from './parseUpdTourn';
import { parseUpdMatchPool } from './parseUpdMatchPool';
import { parseUpdTournPool } from './parseUpdTournPool';
import { parseUpdMatch } from './parseUpdMatch';
import { parseUpdMatchAdm } from './parseUpdMatchAdm';
import { parseUpdMatchRes } from './parseUpdMatchRes';
import { parseUpdMatchPoolV2 } from './parseUpdMatchPoolV2';
import { parseUpdTournPoolV2 } from './parseUpdTournPoolV2';
import { parseUpdTournV2 } from './parseUpdTournV2';
import { getFootballTopics } from './common'

export const parseMessage = (topic, message, contentRef, loadMatchQuery, mQueue, option) => {
    try{
        if(['RESULTS'].includes(contentRef.current.page)) return
        let topicInfo = parseTopic(topic, contentRef);
        //  console.debug("topicinfo ",topicInfo, "message",message);
         let msgCacheId
         let msgCacheType

        if(topicInfo.isV2){
            if(topicInfo.touUpd){
                parseUpdTournV2(message, topicInfo, contentRef);
                return
            }
        }

        if(topicInfo.touNew){
            parseNewTourn(message, topicInfo, contentRef);
        }
        else if(topicInfo.matNew){
            parseNewMatch(message, topicInfo, contentRef);
            msgCacheId = message.id
            msgCacheType = 'matNew'
        }
        else if(topicInfo.pooNew){
            parseNewMatchPool(message, topicInfo, contentRef);
            msgCacheId = topicInfo.matchid
            msgCacheType = 'pooNew'
        }
        else if(topicInfo.chpPooNew){
            if(!contentRef.current.config.TOURNAMENT_PAGE.includes(contentRef.current.page)) {
                parseNewMatchPool(message, topicInfo, contentRef);
            }
            else{
                parseNewTournPool(message, topicInfo, contentRef);
            }
        }
        else if(topicInfo.touUpd){
            parseUpdTourn(message, topicInfo, contentRef);
        }
        else if(topicInfo.poolUpd){
            parseUpdMatchPoolV2(message, topicInfo, contentRef, loadMatchQuery, option);
            msgCacheId = topicInfo.matchid
            msgCacheType = 'poolUpd'
        }
        else if(topicInfo.chpPooUpd){
            if(!contentRef.current.config.TOURNAMENT_PAGE.includes(contentRef.current.page)){
                parseUpdMatchPoolV2(message, topicInfo, contentRef, loadMatchQuery, option);
            }
            else {
                parseUpdTournPoolV2(message, topicInfo, contentRef, option);
            }
        }
        else if(topicInfo.matchUpd){
            parseUpdMatch(message, topicInfo, contentRef, loadMatchQuery, mQueue);
            msgCacheId = topicInfo.matchid
            msgCacheType = 'matchUpd'
        }
        else if(topicInfo.matchAdminUpd){
            parseUpdMatchAdm(message, topicInfo, contentRef);
        }
        else if(topicInfo.matchWagUpd){
            parseUpdMatchRes(message, topicInfo, contentRef);
        }
    }
    catch (e) {
        console.error(e, e.stack);
    }
    
}